import { render, staticRenderFns } from "./CatalogTouristInfosFrom.vue?vue&type=template&id=13742874&"
import script from "./CatalogTouristInfosFrom.vue?vue&type=script&lang=js&"
export * from "./CatalogTouristInfosFrom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports